import React, { useEffect, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Logo from "../assets/kvl-png.png";
import { getVisitorCount, addVisitor } from "../store/slices/visitor";

import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function Footer() {
  const dispatch = useDispatch();

  const { visitorCount } = useSelector((state) => state.visitor);

  useEffect(() => {
    const hasVisited = localStorage.getItem("visited");

    if (!hasVisited) {
      dispatch(addVisitor()).then(() => {
        localStorage.setItem("visited", "true");
      });
    } else {
      dispatch(getVisitorCount());
    }
  }, [dispatch]);

  return (
    <>
      <footer
        style={{
          color: "#6b1f2d",
          backgroundColor: "#fff",
          paddingTop: "30px",
          width: "100%",
        }}
      >
        <Container fluid className="px-5">
          <Row className="gy-3">
            <Col lg={3} md={6}>
              <div className="d-flex align-items-center mb-3">
                <img
                  src={Logo}
                  alt="KVL Matrimony"
                  className="footer-logo"
                />

                <div className="ms-3">
                  <h3
                    className="mb-1"
                    style={{
                      color: "#7b1e3b",
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontWeight: "700",
                    }}
                  >
                    KVL Matrimony
                  </h3>

                  <div
                    style={{
                      color: "#b8860b",
                      fontSize: "11px",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                    }}
                  >
                    Trusted Lingayat Matrimony
                  </div>
                </div>
              </div>

              <p
                style={{
                  fontSize: "14px",
                  color: "#666",
                  lineHeight: "1.8",
                }}
              >
                India's most trusted <strong>Lingayat</strong> matrimonial
                platform. Find your perfect life partner through verified
                profiles and secure matchmaking.
              </p>

              <div className="d-flex gap-3 mt-3">
                <div style={iconStyle}>
                  <FaFacebookF />
                </div>
                <div style={iconStyle}>
                  <FaInstagram />
                </div>
                <div style={iconStyle}>
                  <FaTwitter />
                </div>
                <div style={iconStyle}>
                  <FaYoutube />
                </div>
              </div>
            </Col>

            {/* Quick Links */}

            <Col lg={3} md={6}>
              <h6
                className="fw-bold mb-3"
                style={{ color: "#7b1e3b" }}
              >Quick Links</h6>

              <p className="footer-link mb-1" onClick={() => window.location.href = "/about-us"}>About Us</p>
              <p className="footer-link mb-1" onClick={() => window.location.href = "/how-it-works"}>How It Works</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/contact"}>Contact Us</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/faq"}>FAQs</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/report-abuse"}>Report Abuse</p>
              {/* <p className="footer-link mb-2" onClick={() => window.location.href = "/success-stories"}>Success Stories</p> */}

            </Col>

            {/* Help & Support */}

            <Col lg={3} md={6}>
              <h6
                className="fw-bold mb-3"
                style={{ color: "#7b1e3b" }}
              >Policies</h6>


              <p className="mb-1 footer-link" onClick={() => window.location.href = "/privacy"}>Privacy Policy</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/terms"}>Terms of Service</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/platform-usage"}>Platform Usage Policy</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/payment-policy"}>Payment Policy</p>
              <p className="mb-1 footer-link" onClick={() => window.location.href = "/compliance"}>Corporate Compliance</p>

            </Col>

            {/* Contact */}

            <Col lg={3} md={6}>
              <h6
                className="fw-bold mb-3"
                style={{ color: "#7b1e3b" }}
              >Get In Touch</h6>

              <p
                className="d-flex align-items-center gap-2 mb-2 "

              >
                <FaEnvelope className="text-warning" />
                <a
                  href="mailto:support@kvlmatrimony.com"
                  className=" text-decoration-none footer-contact-link footer-link"
                >
                  support@kvlmatrimony.com
                </a>
              </p>
              <p
                className="d-flex align-items-center gap-2 mb-2"

              >
                <FaPhoneAlt className="text-warning" />
                <a
                  href="tel:+919606010981"
                  className=" text-decoration-none footer-contact-link footer-link"
                >
                  +91-9606010981
                </a>
              </p>

              <p className="d-flex align-items-center gap-2 footer-link" >
                <FaMapMarkerAlt className="text-warning" size="30px" />
                No.88, R.B.D Gubbi Thotadappa Chatra, Near City Railway Station, Gubbi Thodappa Road, Bangalore - 560023
              </p>

              {/* App Buttons */}
            </Col>
          </Row>

          {/* Divider */}

          <hr style={{ margin: "15px 0", borderColor: "#c78b4c" }} />

          {/* Bottom Bar */}
          <Row className="pb-3 align-items-center">
            <Col md={6}>
              <small style={{ color: "#777" }}>
                © 2026 KVL Matrimony. All rights reserved
                <br />
                👥 Visitors: <strong>{(visitorCount || 0).toLocaleString()}</strong>
              </small>
            </Col>

            <Col md={6} className="text-md-end">
              <small style={{ color: "#777" }}>
                Developed by{" "}
                <a
                  href="https://www.octaloptimum.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                  style={{ color: "#b8860b" }}
                >
                  Octal Optimum
                </a>
              </small>
            </Col>


          </Row>
        </Container>
      </footer>
    </>
  );
}

const iconStyle = {
  width: "35px",
  height: "35px",
  background: "rgba(255,255,255,0.1)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
  cursor: "pointer",
};

